"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = new SearchState();
        this.onSearchTextChange = this.onSearchTextChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    onSubmit(event) {
        event.preventDefault();
        this.props.executeAction(fluxible_router_1.navigateAction, {
            url: '/blog?search=' + this.state.searchText,
            method: 'GET',
        });
    }
    onSearchTextChange(event) {
        this.setState({ searchText: event.target.value });
    }
    render() {
        return (React.createElement("section", { className: 'search-section' },
            React.createElement("div", { className: 'container' },
                React.createElement("div", { className: 'tb' },
                    React.createElement("div", { className: 'tb-cell' },
                        React.createElement("div", { className: 'text-content' },
                            React.createElement("h2", null, "What do u want to read about?"),
                            " ",
                            React.createElement("p", null, "My blog will tell you about famous beauty spots and other travel tips."))),
                    React.createElement("div", { className: 'tb-cell' },
                        React.createElement("div", { className: 'search-box' },
                            React.createElement("form", { className: 'search', onSubmit: this.onSubmit, role: 'search' },
                                React.createElement("div", { className: 'form-item' },
                                    React.createElement("input", { type: 'search', name: 's', value: this.state.searchText, onChange: this.onSearchTextChange, placeholder: 'Search destinations, transport, food, ... ', defaultValue: '' })),
                                React.createElement("div", { className: 'form-actions' },
                                    React.createElement("input", { type: 'submit', value: 'Search' })))))))));
    }
}
class SearchState {
}
exports.default = Search;
